import React, { useEffect, useState } from 'react';
import './css/AboutSection.css';
import { motion } from 'framer-motion';
import aboutImg from '../Assets/Image/aboutus.webp';
import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const defaultAbout = {
  eyebrow: 'WHALES ADVISOR',
  heading: 'About Us',
  body:
    'Whales Advisory is a distinguished professional services firm delivering refined, solution-driven legal support across the Egyptian market. We specialize in simplifying complex regulatory frameworks for start-ups, SMEs, and large corporates. By leveraging strong relationships with governmental authorities and deep local expertise, we enable local and international businesses to operate and expand with absolute confidence.',
  subtitle: 'We deliver end‑to‑end solutions from idea to production.',
  eyebrowFontSize: 13,
  headingFontSize: 38,
  bodyFontSize: 16,
  subtitleFontSize: 13,
};

const AboutSection = () => {
  const [about, setAbout] = useState(defaultAbout);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/about-section`);
        setAbout((current) => ({ ...current, ...response.data }));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };

    fetchAbout();
  }, []);

  return (
    <motion.section
      className="about-section-wrapper"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, ease: 'easeOut' }}
    >
      <div className="about-section-card">
        {/* Left: Content */}
        <div className="about-left">
          <p
            className="about-eyebrow"
            style={{ fontSize: `${about.eyebrowFontSize}px` }}
          >
            {about.eyebrow}
          </p>
          <h2
            className="about-heading"
            style={{ fontSize: `${about.headingFontSize}px` }}
          >
            {about.heading}
          </h2>
          <p
            className="about-body"
            style={{ fontSize: `${about.bodyFontSize}px` }}
          >
            {about.body}
          </p>

          <button
            className="about-cta-btn"
            onClick={() => (window.location.href = '/about')}
          >
            LEARN MORE <span className="about-cta-arrow">→</span>
          </button>

          <p
            className="about-subtitle"
            style={{ fontSize: `${about.subtitleFontSize}px` }}
          >
            {about.subtitle}
          </p>
        </div>

        {/* Right: Image */}
        <div className="about-right">
          <img
            src={aboutImg}
            alt="About our law firm"
            className="about-image corporate-img-filter"
          />
        </div>
      </div>
    </motion.section>
  );
};

export default AboutSection;
